import { Box, Typography } from "@mui/material";
import type * as React from "react";
import { COLORS } from "components/v3/Theme/colors";

const GuidanceCallout: React.FC = () => (
  <Box
    component="section"
    sx={{
      bgcolor: COLORS.BACKGROUND_BLUE,
      borderRadius: "16px",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      p: { md: 3, xs: 2 },
      width: "100%"
    }}
  >
    <Typography component="p" variant="body_strong_black" sx={{ m: 0 }}>
      Not sure which test is right for you?
    </Typography>
    <Typography component="p" variant="body_black" sx={{ m: 0 }}>
      If you&apos;re not sure which test is right for you, have a conversation
      with your healthcare provider. The Genomic Life navigation team can also
      provide more information on your options and even help you identify
      specific questions to ask your provider.
    </Typography>
  </Box>
);

export default GuidanceCallout;
